// Localização: frontend/src/components/Agendamentos/AgendamentoStatusFilter.jsx
// Componente de Filtro de Status para Agendamentos com Dropdown

import React from 'react';
import { Tag, Check, X } from 'lucide-react';

/**
 * @component AgendamentoStatusFilter
 * @description Componente de filtro de status para agendamentos com dropdown
 * @param {Array} status - Array de status selecionados
 * @param {function} onStatusChange - Callback quando status muda
 * @param {function} onClose - Callback para fechar o filtro (opcional)
 * @param {string} className - Classes CSS adicionais
 */
const AgendamentoStatusFilter = ({
    status = [],
    onStatusChange,
    onClose = null,
    className = ''
}) => {
    // Opções de status para agendamentos
    const statusOptions = [
        { value: 'Pendente', label: 'Pendente', bgColor: 'bg-yellow-50', activeBgColor: 'bg-yellow-100', color: 'text-yellow-600', hoverColor: 'hover:bg-yellow-100' },
        { value: 'Em Andamento', label: 'Em Andamento', bgColor: 'bg-blue-50', activeBgColor: 'bg-blue-100', color: 'text-blue-600', hoverColor: 'hover:bg-blue-100' },
        { value: 'Concluído', label: 'Concluído', bgColor: 'bg-green-50', activeBgColor: 'bg-green-100', color: 'text-green-600', hoverColor: 'hover:bg-green-100' },
        { value: 'Cancelado', label: 'Cancelado', bgColor: 'bg-red-50', activeBgColor: 'bg-red-100', color: 'text-red-600', hoverColor: 'hover:bg-red-100' }
    ];

    const handleStatusToggle = (statusValue) => {
        if (!onStatusChange) return;
        
        const currentStatus = status || [];
        let newStatus;
        if (currentStatus.includes(statusValue)) {
            newStatus = currentStatus.filter(s => s !== statusValue);
        } else {
            newStatus = [...currentStatus, statusValue];
        }
        onStatusChange(newStatus);
    };

    return (
        <div className={`bg-white rounded-xl shadow-2xl border border-gray-200 py-2 relative ${className}`}>
            {/* Botão de Fechar */}
            {onClose && (
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 p-1.5 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600 z-10"
                    title="Fechar filtro"
                    aria-label="Fechar filtro"
                >
                    <X className="h-4 w-4" />
                </button>
            )}

            {/* Conteúdo do dropdown */}
            <div className="pt-1">
                {statusOptions.map(option => {
                    const isSelected = status?.includes(option.value);
                    return (
                        <button
                            key={option.value}
                            onClick={() => handleStatusToggle(option.value)}
                            className={`
                                w-full flex items-center gap-3 px-4 py-2.5
                                hover:bg-gray-50 transition-colors
                                text-left
                                ${isSelected ? 'bg-emerald-50' : ''}
                            `}
                        >
                            <div className={`
                                flex items-center justify-center w-5 h-5 rounded border-2 transition-colors
                                ${isSelected 
                                    ? 'bg-emerald-600 border-emerald-600' 
                                    : 'border-gray-300 bg-white'
                                }
                            `}>
                                {isSelected && (
                                    <Check className="h-3 w-3 text-white" />
                                )}
                            </div>
                            <span className={`text-sm font-medium ${isSelected ? 'text-emerald-700' : 'text-gray-700'}`}>
                                {option.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default AgendamentoStatusFilter;

